import { useEventListener } from 'ahooks';
import { Store } from 'components/StoreScopes';
import { useStoreNameConfig } from 'hooks/business/store/useStoreName';
import useModal from 'hooks/useModal';
import { RefObject, useMemo } from 'react';
import { StoreIdsSelectModal } from 'views/Aide/components/StoreIdSelect';

function useNeuronStoreIdsSelect({
  neuronId,
  iframeRef,
  storeMap,
  storeGroupStoreList,
}: {
  neuronId: string;
  iframeRef: RefObject<HTMLIFrameElement>;
  storeMap?: Partial<Record<number, Store.Store>>;
  storeGroupStoreList: Store[];
}) {
  const { visible, show, hide, meta = [] } = useModal<string[]>();

  const { configMap: storeNameConfigMap } = useStoreNameConfig();

  useEventListener('message', (e) => {
    if (
      !e.data ||
      e.data.neuronId !== neuronId ||
      !iframeRef.current ||
      !iframeRef.current.contentWindow
    ) {
      return;
    }

    if (e.data.type === 'showStoreIdsSelect') {
      show(e.data.data);
    }

    if (e.data.type === 'getStoreGroupStoreListData') {
      iframeRef.current.contentWindow.postMessage(
        {
          type: 'storeGroupStoreListData',
          data: {
            storeGroupStoreList,
            storeNameConfigMap,
          },
          neuronId,
        },
        '*',
      );
    }
  });

  const modal = (
    <StoreIdsSelectModal
      visible={visible}
      onCancel={() => hide()}
      value={useMemo(() => meta.map(Number), [meta])}
      onChange={(value) => {
        iframeRef.current?.contentWindow?.postMessage(
          {
            type: 'selectStoreIds',
            data: value.map(String),
            neuronId,
          },
          '*',
        );
      }}
      storeDataSource={storeGroupStoreList}
      storeMap={storeMap}
    />
  );

  return {
    modal,
  };
}

export default useNeuronStoreIdsSelect;
